<md-content-box
	class="lesson-card"
	padding="xl"
	[type]="cardType()"
	[class.lesson-card--normal]="highlight() === 'current'"
	[class.lesson-card--scroll-active]="isScrollActive()"
	[class.lesson-card--static]="!clickable()"
>
	<!-- Header: date pill + weekday/time + user info + lesson number -->
	<div class="lesson-card__header">
		<div class="lesson-card__header-start">
			<div class="date-pill" [class.date-pill--current]="isCurrent()" [class.date-pill--error]="hasError()" [class.date-pill--warning]="hasWarning()">
				<span class="date-pill__date">{{ lessonDate() | tzDate: 'MMM d' }}</span>
				<span class="date-pill__year">{{ lessonDate() | tzDate: 'y' }}</span>
			</div>
			<div class="lesson-card__datetime">
				<span class="datetime__weekday">{{ lessonDate() | tzDate: 'EEEE' }}</span>
				<span class="datetime__time">{{ lessonDate() | tzTime: 'hh:mma' }} – {{ lessonEndTime() | tzTime: 'hh:mma' }}</span>
			</div>
		</div>
		@if (lessonUser().userID) {
			<div class="lesson-card__user" (click)="openUserDetail()" [class.lesson-card__user--clickable]="canOpenUserDetail()">
				<lb-user-icon [userID]="lessonUser().userID"></lb-user-icon>
				@if (lessonUser().fullName) {
					<div class="lesson-card__user-info">
						<span class="lesson-card__user-name">{{ lessonUser().fullName }}</span>
						<span class="lesson-card__user-role">{{ lesson().languageName }} {{ lessonUser().role }}</span>
					</div>
				}
			</div>
		}
		<div class="lesson-card__header-end">
			@if (lesson().languageLevelName) {
				<md-tag class="lesson-card__lesson-number"> Semester {{ lesson().languageLevelName }}</md-tag>
			}

			@if (lessonNumber() !== null) {
				<md-tag class="lesson-card__lesson-number"> Lesson {{ lessonNumber() | number: '1.0' }} </md-tag>
			}
		</div>
	</div>

	<lb-divider></lb-divider>

	<!-- Controls: chips left, actions right -->
	<div class="lesson-card__controls" (click)="$event.stopPropagation()">
		<div class="lesson-card__chips">
			@if (showTypeDropdown()) {
				<lb-lesson-dropdowns [lesson]="lesson()" [showAttendance]="false" (dataChanged)="dataChanged.emit()"></lb-lesson-dropdowns>
			} @else {
				<md-tag type="tertiary" class="chip--icon">
					<md-icon [icon]="lessonTypeIcon()"></md-icon>
					{{ lesson().lessonTypeName }}
				</md-tag>
			}

			@for (tag of statusTags(); track tag.text) {
				<md-tag [type]="tag.type ?? 'tertiary'" class="chip--icon">
					<md-icon [icon]="tag.icon ?? 'untitled-ui/time/calendar'"></md-icon>
					{{ tag.text }}
				</md-tag>
			}

			@if (showAttendanceTag()) {
				<md-tag [type]="lesson().attendanceStatusID === 2 ? 'warning' : 'success'" class="chip--icon">
					<md-icon [icon]="lesson().attendanceStatusID === 2 ? 'untitled-ui/general/slash-circle-01' : 'untitled-ui/general/check-circle'"></md-icon>
					{{ lesson().attendanceStatusName }}
				</md-tag>
			}

			@if (semesterLessonTypeTag()) {
				<md-tag type="info" class="chip--icon">
					@if (semesterMilestoneIcon()) {
						<md-icon [icon]="semesterMilestoneIcon()!"></md-icon>
					}
					{{ semesterLessonTypeTag() }}
				</md-tag>
			}

			@if (showLocked()) {
				<md-tag type="warning" class="chip--icon" md-tooltip="This lesson is locked and cannot be edited.">
					<md-icon icon="untitled-ui/security/lock-01"></md-icon>
					Locked
				</md-tag>
			}
		</div>

		@if (showActions()) {
			<div class="lesson-card__actions">
				@if (isCurrent()) {
					<a href="https://teams.microsoft.com/?web=1" target="_blank" md-button-brand>Join</a>
				}

				@if (canReschedule()) {
					<button md-button (click)="reschedule()">Reschedule</button>
				}

				@if (showDetails()) {
					@if (needsToLogLesson()) {
						<button md-button-brand (click)="onClick()">Log Lesson</button>
					} @else {
						<button md-button (click)="onClick()">View Lesson</button>
					}
				}

				@if (menuOptions().length > 0) {
					<md-menu
						[menuItems]="menuOptions()"
						triggerIcon="untitled-ui/general/dots-horizontal"
						md-button
						(click)="$event.stopPropagation()"
					></md-menu>
				}
			</div>
		}
	</div>

	@if (showActions()) {
		@if (showSurveys()) {
			<lb-divider></lb-divider>
			<div class="lesson-card__surveys" (click)="$event.stopPropagation()">
				@for (survey of surveys(); track survey.surveyID) {
					<md-content-box type="tertiary" class="survey-row" padding="sm">
						<md-status-icon status="tertiary" icon="untitled-ui/media/lightbulb-04" iconLibrary="untitled-ui" [plain]="true"></md-status-icon>
						<span class="survey-row__name">{{ survey.surveyName }}</span>
						<div class="survey-row__actions">
							<lb-survey-action
								[isAvailable]="survey.isAvailable"
								[isSubmitted]="survey.isSubmitted"
								[canSubmit]="survey.canSubmit"
								(action)="openSurveyDialog(survey)"
							></lb-survey-action>
						</div>
					</md-content-box>
				}
			</div>
		}

		@if (showGrades()) {
			<lb-divider></lb-divider>
			<div class="lesson-card__grades">
				@for (grade of lesson().grades ?? []; track grade.gradingTemplateCategoryID) {
					<lb-grade-tag [grade]="grade.gradeName" [hexColor]="grade.gradeColor" [categoryName]="grade.categoryName" [compact]="true"></lb-grade-tag>
				}
				@if (lesson().lessonSummary) {
					<button md-button (click)="openSummaryDialog(); $event.stopPropagation()">
						<md-icon md-tooltip="View Summary" icon="untitled-ui/general/menu-02"></md-icon>
					</button>
				}
			</div>
		}
	}
</md-content-box>
